/**
 * replaces upload input with label that shows the selected filenames
 */
export function fakeUploadField() {

    $('.powermail_fieldwrap_type_file').find('input[type="file"]').change(function () {
        let uploadField = $(this).parents('.powermail_fieldwrap_type_file');
        let uploadText = uploadField.find('.fake-upload-label')
            .data('upload-text');

        let fileNames = '';
        let files = this.files;
        for (let i = 0; i < files.length; i++) {
            fileNames += (files[i].name + ', ');
        }
        fileNames = fileNames.slice(0, -2);

        if (fileNames === '') {
            uploadField.find('.fake-upload-label')
                .removeClass('file-selected')
                .text(uploadText);
        } else {
            uploadField.find('.fake-upload-label')
                .addClass('file-selected')
                .text(fileNames);
        }
    });

    $('.cancel-upload-button').click(function () {
        let uploadField = $(this).parents('.powermail_fieldwrap_type_file');
        let fileSelected = $(this).siblings('.fake-upload-label')
            .hasClass('file-selected');

        if (fileSelected) {
            uploadField.find('input')
                .val(null)
                .trigger('change');
        } else {
            uploadField.find('.fake-upload-label')
                .trigger('click');
        }
    });
}
